import { useState } from 'react'

import { endOfISOWeek, isAfter, startOfISOWeek } from 'date-fns'

export interface WeekNavigationState {
  startDate: Date
  endDate: Date
  handleDateRangeChange: (newStartDate: Date, newEndDate: Date) => void
}

export const useWeekNavigation = (): WeekNavigationState => {
  const [startDate, setStartDate] = useState<Date>(startOfISOWeek(new Date()))
  const [endDate, setEndDate] = useState<Date>(endOfISOWeek(new Date()))

  const handleDateRangeChange = (newStartDate: Date, newEndDate: Date) => {
    const currentWeekEnd = endOfISOWeek(new Date())

    const maxEndDate = isAfter(newEndDate, currentWeekEnd) ? currentWeekEnd : newEndDate

    const maxStartDate = isAfter(newStartDate, currentWeekEnd)
      ? startOfISOWeek(currentWeekEnd)
      : newStartDate

    setStartDate(maxStartDate)
    setEndDate(maxEndDate)
  }

  return {
    startDate,
    endDate,
    handleDateRangeChange,
  }
}
